import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  titleLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      width: theme.spacing(31.25),
      height: theme.spacing(6.25),
    },
  },

  countUp: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(8),
  },

  button: {
    opacity: 0,
    '&.MuiButton-root': {
      color: theme.palette.text.primary,
    },
  },

  buttonVisible: {
    opacity: 1,
  },
}));
